import { render, staticRenderFns } from "./departmentModel.vue?vue&type=template&id=4b8b106b"
import script from "./departmentModel.vue?vue&type=script&lang=js"
export * from "./departmentModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b8b106b')) {
      api.createRecord('4b8b106b', component.options)
    } else {
      api.reload('4b8b106b', component.options)
    }
    module.hot.accept("./departmentModel.vue?vue&type=template&id=4b8b106b", function () {
      api.rerender('4b8b106b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administrators/accountManage/departmentModel.vue"
export default component.exports